import React, { useEffect, useState } from "react";
import { Check, X, Trash2, EyeOff } from "lucide-react";
import api from "@/lib/api";
import { Stars } from "@/components/Brand";
import { toast } from "sonner";

export default function AdminReviews() {
  const [reviews, setReviews] = useState([]);
  const load = () => api.get("/admin/reviews").then(({ data }) => setReviews(data));
  useEffect(() => { load(); }, []);

  const moderate = async (id, status) => { await api.patch(`/admin/reviews/${id}`, { status }); load(); toast.success(`Review ${status}`); };
  const del = async (id) => { await api.delete(`/admin/reviews/${id}`); load(); };

  const COLOR = { approved: "text-green-600", pending: "text-amber-600", rejected: "text-red-600", hidden: "text-gray-500" };

  return (
    <div>
      <h1 className="font-heading font-extrabold text-3xl mb-1">Reviews</h1>
      <p className="text-sm text-muted-foreground mb-5">Approve, hide or delete customer reviews.</p>
      <div className="grid gap-3">
        {reviews.length === 0 && <p className="text-muted-foreground text-sm">No reviews yet.</p>}
        {reviews.map((r) => (
          <div key={r.id} data-testid={`review-${r.id}`} className="bg-white border border-gray-100 rounded-2xl p-4">
            <div className="flex justify-between items-start">
              <div>
                <Stars rating={r.rating} />
                <p className="text-sm mt-2">“{r.comment}”</p>
                <p className="text-xs text-muted-foreground mt-1">{r.name} · {new Date(r.date).toLocaleDateString()} · <span className={`font-semibold uppercase ${COLOR[r.status]}`}>{r.status}</span></p>
              </div>
              <div className="flex gap-1">
                {r.status !== "approved" && <button data-testid={`approve-${r.id}`} onClick={() => moderate(r.id, "approved")} className="p-2 rounded-full bg-green-50 text-green-600 hover:bg-green-100"><Check size={16} /></button>}
                {r.status !== "rejected" && <button onClick={() => moderate(r.id, "rejected")} className="p-2 rounded-full bg-red-50 text-red-600 hover:bg-red-100"><X size={16} /></button>}
                <button onClick={() => moderate(r.id, "hidden")} className="p-2 rounded-full bg-gray-50 text-gray-600 hover:bg-gray-100"><EyeOff size={16} /></button>
                <button onClick={() => del(r.id)} className="p-2 rounded-full bg-gray-50 text-metros-red hover:bg-gray-100"><Trash2 size={16} /></button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
